export function isDef(val) {
    return val !== undefined && val !== null;
}
export function isFunction(val) {
    return typeof val === 'function';
}
export function isObject(val) {
    return val !== null && typeof val === 'object';
}
export function isPromise(val) {
    return isObject(val) && isFunction(val.then) && isFunction(val.catch);
}
export function isDate(val) {
    return (Object.prototype.toString.call(val) === '[object Date]' &&
        !Number.isNaN(val.getTime()));
}
export function isMobile(value) {
    value = value.replace(/[^-|\d]/g, '');
    return /^((\+86)|(86))?(1)\d{10}$/.test(value) || /^0[0-9-]{10,13}$/.test(value);
}
export function isNumeric(val) {
    return typeof val === 'number' || /^\d+(\.\d+)?$/.test(val);
}
